import { Controller } from "@hotwired/stimulus"

// Handles the dismiss (×) button on portfolio insight cards.
// Card click navigation is handled by the `<a>` wrapping the card content;
// the analytics controller fires "Portfolio Insight Clicked" on link click.
export default class extends Controller {
  static values = { dismissUrl: String }

  dismiss(event) {
    event.preventDefault()
    event.stopPropagation()

    const type = event.currentTarget.dataset.portfolioInsightsTypeParam
    const card = event.currentTarget.closest("[data-insight-card]")
    if (!type || !card) return

    const token = document.querySelector("meta[name='csrf-token']")?.content

    fetch(this.dismissUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": token || ""
      },
      credentials: "same-origin",
      body: JSON.stringify({ insight_type: type })
    }).then((response) => {
      if (!response.ok) return
      card.remove()
    })
  }
}
